export const stubUp = (stub) => {
    return {
        type: 'STUB_UP',
        payload: stub

    }
}
export const headUp = (heading) => {
    return {
        type: 'HEAD_UP',
        payload: heading
    }

}
export const stubDown = (stub) => {
    return {
        type: 'STUB_DOWN',
        payload: stub
    }
}
export const headingDown = (heading) => {
    return {
        type: 'HEADING_DOWN',
        payload: heading
    }
}
export const moveLeft = (heading) => {
    return {
        type: 'HEAD_LEFT',
        payload: heading
    }
}
export const moveRight = (stub) => {
    return {
        type: 'STUB_RIGTH',
        payload: stub
    }
}
export const setColumnFromMetadata = (stub, heading) => {
    return {
        type: 'SET_COLUMN_FROM_METADATA',
        payload: {
            stub,
            heading
        }
    }
}
export const setStubHeadingFromColumn = (stub, heading) =>{
    return {
        type: 'SET_STUB_HEADING_FROM_COLUMN',
        payload: {
            stub,
            heading
        }
    }
}